import React, { forwardRef } from 'react';

import MUITab, { TabProps as MUITabProps } from '@material-ui/core/Tab';

export interface TabProps extends MUITabProps {
  component?: string;
  href?: string;
}

const Tab = forwardRef<HTMLDivElement, TabProps>((props, ref) => {
  return (
    <MUITab {...props} ref={ref}>
      {props.children}
    </MUITab>
  );
});

export default Tab;
